// Translations are exported to translations.json by `rake i18n:export` — see
// config/i18n.yml — and bundled by Vite.
import { I18n } from "i18n-js";
import translations from "./translations.json";

const metaContent = (name) =>
  document.querySelector(`meta[name="${name}"]`)?.content;

const i18n = new I18n(translations);

i18n.defaultLocale = metaContent("i18n-default-locale") || "nl";
i18n.locale = metaContent("i18n-locale") || i18n.defaultLocale;

// ~327 call sites use the bare global rather than importing this module.
window.I18n = i18n;

export default i18n;
